<template>
  <a-form
    :form="form"
    @submit="save"
    class="pop-common-form"
    :style="{width: '700px', margin: '0 auto'}">
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      hasFeedback>
      <template slot="label">
        <span class="">B账号</span>
      </template>
      <Input
        :value="userInfo && userInfo.userName"
        disabled
      />
    </a-form-item>
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      hasFeedback>
      <template slot="label">
        <span class="">账号昵称</span>
      </template>
      <Input
        placeholder="请输入昵称"
        :value="form.name.value"
        disabled
      />
    </a-form-item>
    <a-form-item
      class="form-item"
      v-bind="formItemLayout"
      :validate-status="form.newEmail.validateStatus"
      :help="form.newEmail.help"
      hasFeedback>
      <template slot="label">
        <span class="required">新邮箱</span>
      </template>
      <Input
        placeholder="请输入新的邮箱"
        v-model="form.newEmail.value"
        @change="validateHandler('newEmail', $event)"
      />
    </a-form-item>
    <sendmobile
      :phone="userInfo && userInfo.phone"
      :value.sync="form.newCode.value"
      :validateStatus="form.newCode.validateStatus"
      :help="form.newCode.help"
      :isSendCode.sync = isSendCode
      service-type="PWD"
      @resetCode="getNewCode"
      @checkCode="checkCode"
    />
    <a-form-item
      class="form-item"
      label=" "
      v-bind="formItemLayout">
      <Button class="op-btn" type="primary" @click="save" :disabled="isDisabled">保存</Button>
      <Button class="op-btn" @click="prev">上一步</Button>
    </a-form-item>
  </a-form>

</template>

<script>
  import { Input, Button } from 'ant-design-vue'
  import queryString from 'query-string'
  import form from "@utils/form";
  import vuexMapper from '@mixins'
  import {$http, util} from "@utils";
  import api from "@utils/api";
  import ModifyEmailParam from "../classes/modifyEmailParam";
  import Sendmobile from "@components/sendsms/sendmobile";
  import CheckVcodeParam from "../classes/checkVcodeParam";
  export default {
    name: "emailTwoStep",
    components: {
      Sendmobile,
      Input,
      Button
    },
    mixins: [ form, vuexMapper ],
    props: {
      form: {
        type: Object
      }
    },
    data() {
      return {
        isSendCode: false
      }
    },
    mounted() {
      util.$tracker(157, '288925',10000);
    },
    methods: {
      async getNewCode() {
        if (await this.validateFields(['newEmail'])) {
          this.isSendCode = true
        } else {
          this.isSendCode = false
        }
      },
      checkCode() {
        // 校验验证码一栏是是否正确
        this.validateFields(['newEmail'])
      },
      prev () {
        this.form.newEmail.value = ''
        this.form.newEmail.validateStatus = ''
        this.form.newEmail.help = ''
        this.form.newCode.value = ''
        this.form.newCode.validateStatus = ''
        this.form.newCode.help = ''
        this.$emit('change', 'EmailOneStep')
      },
      async modifyEmail (param) {
        const { code, msg } = await $http.post(`${api.mainHost}${api.mainContentPath}/account/modifyEmail.do`, queryString.stringify({ param }), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        if (code * 1 === 1) {
          this.$message.success('修改成功！')
          this.$router.push({
            name: 'safe'
          })
        } else {
          this.$message.error(msg)
        }
      },
      async save () {
        if (await this.validateFields(['newEmail', 'newCode'])) {
          const { userInfo, form } = this
          const { newEmail, newCode } = form
          this.modifyEmail(
            JSON.stringify(
              new ModifyEmailParam(
                new CheckVcodeParam(userInfo.phone, newCode.value),
                userInfo.phone,
                newEmail.value,
                userInfo.id
              )))
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
